import { Show } from "solid-js";

import { useWorkspace } from "~/lib/hooks";

type Props = {
  wsKey: string;
};

export function SuspensionBanner(props: Props) {
  const workspace = useWorkspace(() => props.wsKey);

  return (
    <Show when={workspace.data?.read_only}>
      <div
        role="alert"
        aria-live="polite"
        class="bg-warning text-warning-content px-6 py-2 text-sm font-medium flex items-center gap-3"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-5 h-5 shrink-0"
          aria-hidden="true"
        >
          <path d="M12 9v4" />
          <path d="M12 17h.01" />
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
        </svg>
        <span>
          This workspace is read-only. The parent tenant is suspended — contact your administrator.
          Reads continue; writes will be rejected.
        </span>
      </div>
    </Show>
  );
}
